module.exports = __webpack_public_path__ + "img/front_2.0dfed1f1.svg";